/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A time-boxed period in which marker-carrying co-streams count as
 * on-game. endsAt is required so a window cannot be left switched on.
 * 
 * @export
 * @interface DropCampaignWindowBody
 */
export interface DropCampaignWindowBody {
    /**
     * 
     * @type {string}
     * @memberof DropCampaignWindowBody
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof DropCampaignWindowBody
     */
    startsAt: number;
    /**
     * 
     * @type {number}
     * @memberof DropCampaignWindowBody
     */
    endsAt: number;
    /**
     * Tag or title token a creator must carry, e.g. "#MW4Reveal".
     * @type {string}
     * @memberof DropCampaignWindowBody
     */
    marker: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DropCampaignWindowBody
     */
    extraCategories?: Array<string>;
    /**
     * How a matched card reads — "Reveal co-stream".
     * @type {string}
     * @memberof DropCampaignWindowBody
     */
    label?: string;
}

/**
 * Check if a given object implements the DropCampaignWindowBody interface.
 */
export function instanceOfDropCampaignWindowBody(value: object): value is DropCampaignWindowBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('startsAt' in value) || value['startsAt'] === undefined) return false;
    if (!('endsAt' in value) || value['endsAt'] === undefined) return false;
    if (!('marker' in value) || value['marker'] === undefined) return false;
    return true;
}

export function DropCampaignWindowBodyFromJSON(json: any): DropCampaignWindowBody {
    return DropCampaignWindowBodyFromJSONTyped(json, false);
}

export function DropCampaignWindowBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropCampaignWindowBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'startsAt': json['startsAt'],
        'endsAt': json['endsAt'],
        'marker': json['marker'],
        'extraCategories': json['extraCategories'] == null ? undefined : json['extraCategories'],
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function DropCampaignWindowBodyToJSON(json: any): DropCampaignWindowBody {
    return DropCampaignWindowBodyToJSONTyped(json, false);
}

export function DropCampaignWindowBodyToJSONTyped(value?: DropCampaignWindowBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'startsAt': value['startsAt'],
        'endsAt': value['endsAt'],
        'marker': value['marker'],
        'extraCategories': value['extraCategories'],
        'label': value['label'],
    };
}

